import { get, post, put, del } from "../client";
import {
  GET_AUTOMATIONS,
  GET_TEMPLATES,
  CREATE_FROM_TEMPLATE,
  UPDATE_AUTOMATION,
  DELETE_AUTOMATION,
  TOGGLE_AUTOMATION,
  GET_AUTOMATION_RUNS,
} from "../routes";

const AUTOMATIONS = {
  getAll: () => get(GET_AUTOMATIONS),
  getTemplates: () => get(GET_TEMPLATES),
  createFromTemplate: (templateId) => post(CREATE_FROM_TEMPLATE, { templateId }),
  update: (id, data) => put(UPDATE_AUTOMATION(id), data),
  remove: (id) => del(DELETE_AUTOMATION(id)),
  toggle: (id) => put(TOGGLE_AUTOMATION(id), {}),
  getRuns: (id, page = 1) => get(`${GET_AUTOMATION_RUNS(id)}?page=${page}`),
};

export default AUTOMATIONS;
